import { render, staticRenderFns } from "./game-toonsync-summary.vue?vue&type=template&id=60d81314&scoped=true&lang=pug&"
import script from "./game-toonsync-summary.vue?vue&type=script&lang=js&"
export * from "./game-toonsync-summary.vue?vue&type=script&lang=js&"
import style0 from "./game-toonsync-summary.vue?vue&type=style&index=0&id=60d81314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d81314",
  null
  
)

export default component.exports